export default __webpack_public_path__ + "static/media/athens.71b16e82.png";